// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WKAC","question":"styles_question__3Is5-","description":"styles_description__2mXuV"};